import axios from "axios";
import React, { useState, useEffect } from "react";
import { BiEditAlt, BiTrash } from "react-icons/bi";
import { MdOutlineCancel, MdSave } from "react-icons/md";

import EditTagStyles from "../EditTag/EditTagWr";
// toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const token = localStorage.getItem("token");
const EditCat = ({ data, successCallback }) => {
  // getting
  const [texts, setTexts] = useState({});
  const [id, setId] = useState(null);
  useEffect(() => {
    setTexts({
      textUz: data.textUz,
      textUzK: data.textUzK,
      textRu: data.textRu,
      textEn: data.textEn,
    });
    setId(data.id);
  }, [data]);
  const [active, setActive] = useState("textUz");
  const menus = [
    { t: "textUz" },
    { t: "textUzK" },
    { t: "textEn" },
    { t: "textRu" },
  ];

  // editing
  const [textBool, setTextBool] = useState("d-block");
  const [inputBool, setInputBool] = useState("d-none");
  const [input, setInput] = useState("");

  // delete
  const [deletedBoolean, setDeleted] = useState("d-block");
  // edit
  const viewHandle = (v) => {
    if (v === "d-block") {
      setTextBool("d-none");
      setInputBool("d-block");
    } else {
      setTextBool("d-block");
      setInputBool("d-none");
    }
    setInput(texts[active]);
  };
  // save values
  const saveHandle = () => {
    let oldVals = texts;
    oldVals[active] = input;
    oldVals.parentCategory = data.parentCategory;
    oldVals.id = data.id;
    setTexts(oldVals);
    viewHandle("d-none");
    setTag(oldVals, false);
  };
  // deleteHandle
  const deleteHandle = () => {
    let con = confirm(`${data.textUz}-ni o'chirmoqchimisiz`);
    if (con) {
      setTag(data.id, true);
    }
  };
  const setTag = async (body, remove) => {
    const url = `http://164.90.236.174:1988/koinot/category/${
      remove ? body.id : ""
    }`;
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    console.log(body);
    try {
      if (remove) {
        let res = await axios.delete(url, headers);
        setDeleted("d-none");
        successCallback(`${data.textUz} kategoriya o'chirildi`, "s");

        return res;
      } else {
        let res = await axios.post(url, body, headers);

        successCallback(`${data.textUz} kategoriya o'zgartirildi !`, "s");

        return res;
      }
    } catch (error) {
      successCallback(
        `Kategoriyani o'zgartirishda xatolik, internetga ulanganlikni tekshiring yoki logout qilib qayta kiring`,
        "e"
      );
      return { error: true, error };
    }
  };
  return (
    <EditTagStyles className={deletedBoolean}>
      <div className="row my-3">
        {/* tilni almashtirish */}
        <div className="col-4 border p-2 d-flex">
          {menus.map((v, i) => (
            <button
              key={i}
              onClick={() => {
                setActive(v.t);
                setInput(texts[v.t]);
              }}
              className={`btn col-3 ${
                active === v.t ? "btn-success" : "btn-outline-success"
              }`}
            >
              {v.t}
            </button>
          ))}
        </div>
        {/* tilni almashtirish */}
        {/* text va input */}
        <div className="col-4 border p-2">
          <p className={`font-monospace ${textBool}`}>{texts[active]}</p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              saveHandle();
            }}
            className={`form-group w-100 d-flex ${inputBool}`}
          >
            <textarea
              className="form-control"
              id=""
              value={input}
              onChange={(e) => setInput(e.target.value)}
              rows="1"
            ></textarea>
          </form>
        </div>
        {/* text va input */}
        {/* edit, cancel, save, delete*/}
        <div className="col-4 border p-2 d-flex">
          <span className={`${textBool} w-100`}>
            <button
              className="btn btn-info col-6"
              onClick={() => viewHandle("d-block")}
            >
              <BiEditAlt className="text-white" />
            </button>
            <button
              className="btn btn-danger text-white col-6"
              onClick={() => deleteHandle()}
            >
              <BiTrash color="white" />
            </button>
          </span>

          <span className={`${inputBool} w-100`}>
            <button
              className="btn btn-warning col-6"
              onClick={() => viewHandle("d-none")}
            >
              <MdOutlineCancel className="text-danger" />
            </button>
            <button
              onClick={() => saveHandle()}
              className="btn btn-success  col-6"
            >
              <MdSave className="text-white" />
            </button>
          </span>
        </div>
        {/* edit, cancel, save, delete*/}
      </div>
      {/* toast */}
    </EditTagStyles>
  );
};

export default EditCat;



// WEBPACK FOOTER //
// ./src/Components/EditCat/index.js